export default __webpack_public_path__ + "static/media/MDV.d4dbbe8b.svg";